import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import AOS from 'aos';
import Btn from "../../components/btns/Btn";
import Hero from "./components/hero/Hero";
import InfoBox from "../../components/infobox/InfoBox";
import AboutIntro from "../../components/aboutIntro/AboutIntro";
import Process from "../../components/process/Process";
import VideoCta from "./components/videoCta/VideoCta";
import Stats from "../../components/stats/Stats";
import HomeTestimonial from "../../components/homeTestimonial/HomeTestimonial";
import HomeBlog from "./components/blog/HomeBlog";
import GetIntouch from "../../components/getInTouch/GetIntouch";
import Partner from "../../components/partner/Partner";
import 'aos/dist/aos.css';

function Home() {

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const location = useLocation();

  useEffect(() => {
    AOS.init({ duration: 500, easing: 'ease', once: true });
  }, [])

  useEffect(() => {
    window.scroll({top: 0, left: 0, behavior: 'instant'});
  }, [location.pathname])

  return (
    <div className="react-main">
      <Hero />
      <InfoBox />
      <AboutIntro classes={"pt-0"} />
      <div className="section-padding service-container">
        <Container>
          <Row data-aos="fade-up">
            <Col md={12}>
              <ul className="service__list d-grid flex-wrap">
                <li className="service__item d-flex flex-column justify-content-center">
                  <div className="heading mb-0">
                    <h6><span>OUR SERVICES</span></h6>
                    <h3>We Provide Exclusive <span>Worldwide</span> Service</h3>
                    <p>
                    Global reach, tailored solutions, unmatched service—delivering excellence across borders, cultures, and industries worldwide.
                    </p>
                  </div>
                  <div className="mt-3">
                    <Btn to="/services/" type="default" value="ALL SERVICES"  />
                  </div>
                </li>
                <li className="service__item">
                  <a href="/website-development/" className="service__box">
                    <div className="service__icon">
                      <img src="../assets/images/service/web-color-icon.svg" alt="" />
                    </div>
                    <h4>Web Development</h4>
                    <div className="service__text">
                      <p>
                      Xipe Tech is a leading Web Development Company in India delivering high quality web solutions around world for years.
                      </p>
                    </div>
                    <span className="service__cta">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </li>
                <li className="service__item">
                  <a href="/wordpress-development/" className="service__box">
                    <div className="service__icon">
                      <img src="../assets/images/service/mobile-color-icon.svg" alt="" />
                    </div>
                    <h4>Wordpress Development </h4>
                    <div className="service__text">
                      <p>
                      Get your design files converted into fully editable WordPress theme with Advanced Custom Fields Pro plugin.
                      </p>
                    </div>
                    <span className="service__cta">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </li>
                <li className="service__item">
                  <a href="/android-development/" className="service__box">
                    <div className="service__icon">
                      <img src="../assets/images/service/android-color-icon.svg" alt="" />
                    </div>
                    <h4>Android Development</h4>
                    <div className="service__text">
                      <p>
                        The android development process typically involves designing the user interface (UI), implementing app functionality, handling user input, 
                      </p>
                    </div>
                    <span className="service__cta">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </li>
                <li className="service__item">
                  <a href="/ios-development/" className="service__box">
                    <div className="service__icon">
                      <img src="../assets/images/service/ios-color-icon.svg" alt="" />
                    </div>
                    <h4>iOS Development</h4>
                    <div className="service__text">
                      <p>
                      Xipe Tech is the best iOS/iPhone application development company in India. Our expertise in iOS/iPhone/iPad applicaton development with commitment
                      </p>
                    </div>
                    <span className="service__cta">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </li>
                <li className="service__item">
                  <div className="service__box video_box p-0">
                    <div className="service__video_box" onClick={handleShow}>
                      <img src="../assets/images/service/service-video.png" alt="" />
                      <span className="service__video_play">
                        <i className="fa-solid fa-play"></i>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <Process classes="overflow-hidden" />
      <VideoCta classes="overflow-hidden" />
      <Stats classes="pt-0 overflow-hidden" />
      <HomeTestimonial  classes="bg-gray"/>
      <HomeBlog classes="overflow-hidden" />
      <GetIntouch  classes="overflow-hidden" />
      <Partner classes="pt-0 overflow-hidden" />
     
    </div>
  )
}

export default Home
